import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import Config from '../../../../../Config';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import {stageEnums} from '../../Assets/VolteCheckVariables';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {isMobile} from 'react-device-detect';

const NotSupportedStage = (props) => {
  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן <br />
      והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל <br />
      עת. על מנת לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, <br />
      עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל <br />
      עת. על מנת לבדוק אם מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );

  const deviceViewer = props.iContent.supportedDevices?.expandedValue?.map((device, index) => {
    return (
      <div
        className='supportedDevice'
        onClick={() => {
          buildUrlAndOpenSameWindow(device.devicePurchaseUrl?.value);
        }}>
        <Image src={Config.epiBaseUrl + device.imageUrl?.value} />
        <div>{device.title?.value}</div>
      </div>
    );
  });
  return (
    <div className='notSupportedStage'>
      <div className='headBox'>
        <p className='heading'>
          אנחנו מזהים שהמכשיר שלך <br /> לא תומך ביכולת דור 4
        </p>
        <p className='subHeading'>
          כדי להמשיך ליהנות משירותי שיחה וגלישה, <br />
          מומלץ להחליף למכשיר תומך
        </p>
      </div>
      <div className='supportedDevicesContainer'>{deviceViewer}</div>
      {props.iContent.supportedDevicesLink?.value && props.iContent.supportedDevicesText?.value && (
        <a
          href='#'
          className='supportLink'
          onClick={() => {
            buildUrlAndOpenSameWindow(props.iContent.supportedDevicesLink.value);
          }}>
          {props.iContent.supportedDevicesText?.value}{' '}
        </a>
      )}

      <div className='finishFooter'>
        <div className='headBox' style={{marginBottom: '12px'}}>
          <p className='subHeading' style={{marginBottom: '0px'}}>
            מתלבטים מה לבחור? נציג שלנו ישמח לעזור!{' '}
          </p>
        </div>
        {props.data.sentCallback ? (
          <div className='headBox' style={{marginTop: '12px'}}>
            <p className='subHeading' style={{marginBottom: '0px'}}>
              נציגינו יחזרו אליכם בהקדם{' '}
            </p>
          </div>
        ) : (
          <BtnSubmit
            className='mb-12'
            text='שנציג יחזור אליי'
            onclick={() => {
              props.setStage(stageEnums.callback);
            }}
          />
        )}
        {props.subscribersByProduct?.Cellular?.length > 1 && (
          <div className='mb-12'>
            <BtnWhiteBlackBorderBigSize
              text={'חזרה לבחירת מנוי'}
              onclick={() => {
                props.setStage(stageEnums.selectSubscriber);
              }}
            />
          </div>
        )}
        {disclaimerText}
      </div>
    </div>
  );
};

export default NotSupportedStage;
